import { JSX } from "react";

const ProviderIntegrityTrendDescription = (): JSX.Element => {
  return <>
    <p>
      The Integrity Trend card tracks how network integrity is changing over time (up to 12 months).
      The trend card utilizes the same groupings as the Provider Breakdown card, easily visualizing the number of providers with integrity issues across recent analyses to help highlight whether overall integrity is getting better or worse over time.
    </p>
    <ul>
      <li>
        <b>Blue</b>: Passed all integrity checks
      </li>
      <li>
        <b>Yellow</b>: Triggered at least one warning
      </li>
      <li>
        <b>Red</b>: Triggered at least one alert
      </li>
    </ul>
    <p>
      Monitoring network integrity over time helps to spot trends and identify the impact of data improvements as well as emerging integrity risks.
    </p>
    <p>
      <i>Note: Blue, Yellow, and Red bands are mutually exclusive, meaning if a provider has both an alert and a warning, they will be counted in the Red grouping. </i>
    </p>
    <p>
      Provider counts represent Unique Access Points.
    </p>
  </>;
}

export { ProviderIntegrityTrendDescription };